<script>
export default {
    computed:{
        language(){
        return this.$i18n.locale
        }
    },
    methods:{
        handleChangeLanguage(lang){
            this.$i18n.locale = lang
            localStorage.setItem('language',lang)
            this.$emit('change', lang)
        },
    }
};
</script>
<template>
    <div class="form-row justify-content-end mb-3">
        <div role="group" class="btn-group btn-group-sm">
            <button type="button" class="btn " v-bind:class="{ 'btn-info': language=='zh-CN', 'btn-secondary': language!='zh-CN' }" @click="handleChangeLanguage('zh-CN')">中文</button>
            <button type="button" class="btn " v-bind:class="{ 'btn-info': language=='en', 'btn-secondary': language!='en' }" @click="handleChangeLanguage('en')">English</button>
        </div>
    </div>
</template>